<roots-page-header [toolTip]="toolTip" [title]="title" [loading]="loading" (refresh)="getCustomerData(customerId)">
</roots-page-header>
@if (customer) {
  <div class="customer-details-layout">
    <div class="customer-editor">
      <section class="details-section">
        <div class="section-heading">
          <span class="section-icon"><mat-icon>business</mat-icon></span>
          <div>
            <h2>Customer profile</h2>
            <p>General information and account preferences.</p>
          </div>
        </div>
        <div class="details-fields">
          <mat-form-field appearance="outline" class="field-wide">
          <mat-label>Name</mat-label>
          <input matInput placeholder="Name" [(ngModel)]="customer.basicName" required />
        </mat-form-field>
          <mat-form-field appearance="outline" class="field-wide">
          <mat-label>Description</mat-label>
          <textarea matInput rows="2" [(ngModel)]="customer.basicDescription" required></textarea>
        </mat-form-field>
          <mat-form-field appearance="outline">
          <mat-label>Region</mat-label>
          <mat-select placeholder="Region" required [(ngModel)]="customer.regionId" name="region">
            @for (reg of regions | sort: 'key'; track reg) {
              <mat-option [value]="reg.value">
                {{ reg.key }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
          <mat-form-field appearance="outline">
          <mat-label>Language</mat-label>
          <mat-select placeholder="Language" required [(ngModel)]="customer.languageTag" name="languageTag">
            @for (lang of languages | sort: 'key'; track lang) {
              <mat-option [value]="lang.value">
                {{ lang.key }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
          <mat-form-field appearance="outline">
          <mat-label>Customer type</mat-label>
          <mat-select placeholder="Customer Type" required [(ngModel)]="customer.customerTypeId"
            name="customerType">
            @for (cat of types | sort: 'key'; track cat) {
              <mat-option [value]="cat.value">
                {{ cat.key }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
        </div>
      </section>
      <section class="details-section">
        <div class="section-heading">
          <span class="section-icon"><mat-icon>contact_phone</mat-icon></span>
          <div>
            <h2>Primary contact</h2>
            <p>Contact details for this customer.</p>
          </div>
        </div>
        <div class="details-fields">
          <mat-form-field appearance="outline">
          <mat-label>Contact Name</mat-label>
          <input matInput placeholder="Contact Name" [(ngModel)]="customer.contact_Name" />
        </mat-form-field>
          <mat-form-field appearance="outline">
          <mat-label>Contact Telephone</mat-label>
          <input matInput type="tel" placeholder="Contact Telephone" [(ngModel)]="customer.contact_Telephone" required />
        </mat-form-field>
          <mat-form-field appearance="outline" class="field-wide">
          <mat-label>Contact Address</mat-label>
          <input matInput placeholder="Contact Address" [(ngModel)]="customer.contact_Address" required />
        </mat-form-field>
          <mat-form-field appearance="outline">
          <mat-label>Contact Email</mat-label>
          <input matInput placeholder="Contact Email" [(ngModel)]="customer.contact_Email" disabled />
        <mat-hint>Email is managed through the customer account.</mat-hint>
        </mat-form-field>
        </div>
      </section>
      <section class="details-section">
        <div class="section-heading">
          <span class="section-icon"><mat-icon>support_agent</mat-icon></span>
          <div>
            <h2>Support & sales</h2>
            <p>People who support this account.</p>
          </div>
        </div>
        <div class="details-fields">
          <mat-form-field appearance="outline">
          <mat-label>Field Support Contact Name</mat-label>
          <input matInput placeholder="Field Support Contact Name" [(ngModel)]="customer.fieldSupportContact_Name"/>
        </mat-form-field>
          <mat-form-field appearance="outline">
          <mat-label>Sales Contact Name</mat-label>
          <input matInput placeholder="Sales Contact Name" [(ngModel)]="customer.salesContact_Name"/>
        </mat-form-field>
        </div>
      </section>
      <div class="customer-save-bar">
        <span>Review customer details before saving.</span>
        <button mat-raised-button type="button" color="primary" [disabled]="loading" (click)="onUpdate(customer)">
          <mat-icon>save</mat-icon>
          Save changes
        </button>
      </div>
    </div>
    <aside class="customer-related" aria-label="Related customer information">
      <div class="related-heading">
        <h2>Customer activity</h2>
        <p>Notes and linked records for this account.</p>
      </div>
      <app-notes [compact]="true" [entityId]="customer.id" [entityCode]="customer.code" [entityType]="'Customer'"
        [notes]="notes" (noteAdded)="noteAdded($event)">
      </app-notes>
      <app-roots-details-data-list [compact]="true" [data]="adminAssetList" [prop_1]="'name'" [prop_2]="'assetTypeName'"
        [prop_3]="'userAssetName'" [prop_4]="'description'" [prop_5]="'asoWhenBegin'" [prop_6]="'code'" [type]="0"
        [icon]="'widgets'" [title]="'Current Assets'">
      </app-roots-details-data-list>
      <app-roots-details-data-list [compact]="true" [data]="users" [prop_1]="'name'" [prop_2]="'authUsername'" [type]="2" [icon]="'person'"
        [title]="'Current Users'">
      </app-roots-details-data-list>
    </aside>
  </div>
}
